import { cn } from "utils/helpers";

interface ToggleButtonGroupOption {
	label: string;
	value: string;
}

interface ToggleButtonGroupProps {
	options: ToggleButtonGroupOption[];
	value: string | null;
	onChange: (value: string) => void;
}

export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({
	options,
	value,
	onChange,
}) => {
	return (
		<div className="inline-flex gap-2" role="group">
			{options.map((option) => {
				const isActive = option.value === value;

				return (
					<button
						key={option.value}
						type="button"
						aria-pressed={isActive}
						onClick={() => onChange(option.value)}
						className={cn(
							"rounded-lg border px-4 py-2 text-sm font-medium transition-colors",
							"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0031DD] focus-visible:ring-offset-2",
							isActive
								? "border-[#0031DD] bg-[#0031DD] text-white"
								: "border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
						)}
						data-testid={`toggle-btn-${option.value}`}
					>
						{option.label}
					</button>
				);
			})}
		</div>
	);
};
